import { DataModel } from "common/models/utility-models/base-model";

export class AddInternShipModel extends DataModel {

internshipTitle:any = '';
accommodationAddress:any = ''; 
accommodationContactPerson :any = ''; 
guideEmail : any = '';
guideMobile : any = '';
guideName : any = '';
hrEmail : any = '';
hrMobile : any = '';
hrName : any = '';
internshipCompanyId : any = '';
internshipCompanyLocationId :any = ''; 
internshipCompanyMentorId :any = ''; 
internshipEndDate : any = '';
student_ids: any = [];
internshipProjectName:any = ''; 
internshipStartDate : any = '';
year : any = '';
mentorPhone:any="";
mentorEmail:any="";
Address:any="";
student_options: any="";
}











// internshipStartDate
// internshipTitle
// accommodationAddress: 
// accommodationContactPerson : 
// guideEmail : 
// guideMobile : 
// guideName : 
// hrEmail : 
// hrMobile : 
// hrName : 
// internshipCompanyId : 
// internshipCompanyLocationId : 
// internshipCompanyMentorId : 
// internshipEndDate : 
// internshipMasterIds: 
// internshipProjectName: 
// internshipStartDate : 
// internshipTitle : 
// year : 
